/******************************************************************************

BabiGO
Notification Skeleton
=====================

*/

import "./notificationSkeleton.css";

export default function NotificationSkeleton({

    count = 4,

    }) {
        return (

            <div

                className="notification-skeleton"

                role="status"

                aria-label="Chargement des notifications"

                aria-busy="true"

            >

                {

                    Array.from({

                        length: count,

                    }).map((_, index) => (

                        <div

                            className="notification-skeleton-item"

                            key={index}

                        >

                            {/* ==================================================
                                ICÔNE
                            ================================================== */}

                            <div className="notification-skeleton-icon">

                                <span />

                            </div>


                            {/* ==================================================
                                CONTENU
                            ================================================== */}

                            <div className="notification-skeleton-content">

                                <div className="notification-skeleton-title">

                                    <span />

                                </div>


                                <div className="notification-skeleton-message">

                                    <span />

                                    <span />

                                </div>


                                <div className="notification-skeleton-meta">

                                    <span />

                                </div>

                            </div>


                            {/* ==================================================
                                ACTIONS
                            ================================================== */}

                            <div className="notification-skeleton-actions">

                                <span />

                                <span />

                            </div>

                        </div>

                    ))

                }

            </div>
        );

}
